// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DTADocumentContentEdcSourceRulesInner
 */
export interface DTADocumentContentEdcSourceRulesInner {
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentEdcSourceRulesInner
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentEdcSourceRulesInner
     */
    form_name?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentEdcSourceRulesInner
     */
    rule_name?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentEdcSourceRulesInner
     */
    severity?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentEdcSourceRulesInner
     */
    vault_syntax?: string;
}

/**
 * Check if a given object implements the DTADocumentContentEdcSourceRulesInner interface.
 */
export function instanceOfDTADocumentContentEdcSourceRulesInner(value: object): value is DTADocumentContentEdcSourceRulesInner {
    return true;
}

export function DTADocumentContentEdcSourceRulesInnerFromJSON(json: any): DTADocumentContentEdcSourceRulesInner {
    return DTADocumentContentEdcSourceRulesInnerFromJSONTyped(json, false);
}

export function DTADocumentContentEdcSourceRulesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTADocumentContentEdcSourceRulesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'form_name': json['form_name'] == null ? undefined : json['form_name'],
        'rule_name': json['rule_name'] == null ? undefined : json['rule_name'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'vault_syntax': json['vault_syntax'] == null ? undefined : json['vault_syntax'],
    };
}

export function DTADocumentContentEdcSourceRulesInnerToJSON(json: any): DTADocumentContentEdcSourceRulesInner {
    return DTADocumentContentEdcSourceRulesInnerToJSONTyped(json, false);
}

export function DTADocumentContentEdcSourceRulesInnerToJSONTyped(value?: DTADocumentContentEdcSourceRulesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'form_name': value['form_name'],
        'rule_name': value['rule_name'],
        'severity': value['severity'],
        'vault_syntax': value['vault_syntax'],
    };
}
